var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 105 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5595 29.8991L66.7606 0.507935H31.5215L49.3203 29.8991H84.5595Z",
    fill: "#003563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3199 29.8991L20.9405 78.1169C5.13351 78.1169 -4.62637 60.8837 3.49226 47.3235L31.521 0.507935L49.3199 29.8991Z",
    fill: "url(#paint0_linear_1633_5447)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5595 29.8991L66.7606 0.507935H31.5215L49.3203 29.8991H84.5595Z",
    fill: "#003563"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3199 29.8991L20.9405 78.1169C5.13351 78.1169 -4.62637 60.8837 3.49226 47.3235L31.521 0.507935L49.3199 29.8991Z",
    fill: "url(#paint1_linear_1633_5447)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9406 78.1165L38.7394 107.508L73.9785 107.508L56.1797 78.1165L20.9406 78.1165Z",
    fill: "#003563"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1801 78.1165L84.5595 29.8987C100.366 29.8987 110.126 47.1319 102.008 60.6921L73.979 107.508L56.1801 78.1165Z",
    fill: "url(#paint2_linear_1633_5447)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5589 29.8993L56.1796 78.1171H20.9404L49.3198 29.8993H84.5589Z",
    fill: "url(#paint3_radial_1633_5447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1633_5447",
    x1: 39.4079,
    y1: 14.6498,
    x2: 9.33156,
    y2: 61.4574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829198,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1633_5447",
    x1: 39.4079,
    y1: 14.6498,
    x2: 9.33156,
    y2: 61.4574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829198,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1633_5447",
    x1: 66.0921,
    y1: 93.3658,
    x2: 96.1684,
    y2: 46.5582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829198,
    stopColor: "#003366"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1633_5447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7497 54.0082) rotate(119.321) scale(27.6514 36.4832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E78A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.ea4e38491ff9f85def3d306e4de41cb7.svg";
export { ForwardRef as ReactComponent };